export default "__VITE_ASSET__BYXUdNN5__"